"use client";

import { Menu, X } from "lucide-react";
import { useState } from "react";
import Logo from "./Logo";
import { Link } from "react-router-dom";

const navStyle = {
  background: "rgba(17, 24, 39, 0.85)",
  backdropFilter: "blur(20px)",
  WebkitBackdropFilter: "blur(20px)",
  border: "1px solid rgba(28, 37, 54, 0.8)",
};

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      className="fixed z-50"
      style={{
        top: "calc(16px + var(--parlaye-banner-height, 0px))",
        left: "50%",
        transform: "translateX(-50%)",
        width: "calc(100% - 32px)",
        maxWidth: "1100px",
      }}
    >
      {/* Main pill bar */}
      <nav
        style={{
          ...navStyle,
          borderRadius: isOpen ? "16px 16px 0 0" : "16px",
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.4)",
          transition: "border-radius 0.2s ease",
        }}
      >
        <div className="px-5 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <Logo />
            {/* Desktop links */}
            <div className="hidden md:flex items-center justify-between flex-1 ml-10">
              <div className="flex space-x-6">
                <Link to="/" className="text-p-text-secondary hover:text-p-text-primary text-base font-medium transition-colors duration-200">
                  Home
                </Link>
                <a href="#how-it-works" className="text-p-text-secondary hover:text-p-text-primary text-base font-medium transition-colors duration-200">
                  How it works
                </a>
                <Link to="/about" className="text-p-text-secondary hover:text-p-text-primary text-base font-medium transition-colors duration-200">
                  About
                </Link>
                <a href="https://help.parlaye.com/" className="text-p-text-secondary hover:text-p-text-primary text-base font-medium transition-colors duration-200">
                  Support
                </a>
              </div>
              <a
                href="#download"
                className="text-p-bg text-base font-bold px-8 py-3 rounded-xl transition-all duration-200 hover:-translate-y-px"
                style={{
                  background: "linear-gradient(135deg, #19E094, #0fa968)",
                  boxShadow: "0 4px 16px rgba(25, 224, 148, 0.25)",
                }}
                onMouseEnter={(e) => { e.currentTarget.style.boxShadow = "0 6px 24px rgba(25, 224, 148, 0.35)"; }}
                onMouseLeave={(e) => { e.currentTarget.style.boxShadow = "0 4px 16px rgba(25, 224, 148, 0.25)"; }}
              >
                Download
              </a>
            </div>
            {/* Mobile hamburger */}
            <div className="md:hidden flex items-center">
              <button
                onClick={() => setIsOpen(!isOpen)}
                className="text-p-text-secondary hover:text-p-text-primary transition-colors duration-200 p-1"
              >
                {isOpen ? <X size={22} /> : <Menu size={22} />}
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Mobile dropdown — anchored directly below the pill */}
      {isOpen && (
        <div
          className="md:hidden"
          style={{
            ...navStyle,
            borderRadius: "0 0 16px 16px",
            borderTop: "1px solid rgba(28, 37, 54, 0.5)",
            padding: "8px 20px 16px",
          }}
        >
          <div className="flex flex-col gap-1">
            <a
              href="#home"
              className="block text-p-text-secondary hover:text-p-text-primary py-3 text-base font-medium transition-colors duration-200 border-b border-p-border"
              onClick={() => setIsOpen(false)}
            >
              Home
            </a>
            <a
              href="#how-it-works"
              className="block text-p-text-secondary hover:text-p-text-primary py-3 text-base font-medium transition-colors duration-200 border-b border-p-border"
              onClick={() => setIsOpen(false)}
            >
              How it works
            </a>
            <Link
              to="/about"
              className="block text-p-text-secondary hover:text-p-text-primary py-3 text-base font-medium transition-colors duration-200 border-b border-p-border"
              onClick={() => setIsOpen(false)}
            >
              About
            </Link>
            <a
              href="https://help.parlaye.com/"
              className="block text-p-text-secondary hover:text-p-text-primary py-3 text-base font-medium transition-colors duration-200"
              onClick={() => setIsOpen(false)}
            >
              Support
            </a>
            <a
              href="#download"
              className="block text-p-bg text-base font-bold px-6 py-3 rounded-xl mt-2 text-center transition-all duration-200"
              style={{
                background: "linear-gradient(135deg, #19E094, #0fa968)",
                boxShadow: "0 4px 16px rgba(25, 224, 148, 0.25)",
              }}
              onClick={() => setIsOpen(false)}
            >
              Download
            </a>
          </div>
        </div>
      )}
    </div>
  );
}
